import React from "react";
import { Box, Typography } from "@mui/material";
import LinkDisplay from "components/Base/LinkDisplay";

interface LoggingTabProps {
  loggingLink?: string;
  loggingLabel?: string;
}

const LoggingTab: React.FC<LoggingTabProps> = ({
  loggingLink,
  loggingLabel = "Attendance",
}) => {
  const lower = loggingLabel.toLowerCase();

  return (
    <Box>
      <Typography variant="body2" sx={{ mb: 2, opacity: 0.9 }}>
        Send the following link to your team members for them to record {lower}.
      </Typography>

      {loggingLink ? (
        <LinkDisplay
          url={loggingLink}
          openLabel={loggingLabel}
          showCopyButton
          showText
          qrFileName="Attendance-notes-qr-code"
          showQrDownloadButton
          showOpenButton
          withBackground
        />
      ) : (
        <Typography variant="body2" sx={{ opacity: 0.7 }}>
          No {lower} link available.
        </Typography>
      )}
    </Box>
  );
};

export default LoggingTab;